import styled from "styled-components"
import { Flex } from "@netdata/netdata-ui"

const Wrapper = styled(Flex).attrs({
  justifyContent: "between",
  alignItems: "center",
  width: "100%",
  gap: 2,
})``

export default Wrapper
